import React, { type FunctionComponent, useCallback } from 'react'
import { css } from '@emotion/react'
import { Button } from '@retailer-platform/shared-components'
import { type PartnerPickDeviceDatum } from 'domains/partner-pick-devices/types/partnerPickDevices.types'
import { useDomainMessage } from 'domains/partner-pick-devices/utils/domain/intl'
import { PartnerPickDeviceListSetStatusButton } from 'domains/partner-pick-devices/components/list/components/table-cells/actions/components/PartnerPickDeviceListSetStatusButton'

interface Props {
  partnerPickDevice: PartnerPickDeviceDatum
  onEdit: (id: PartnerPickDeviceDatum['id']) => void
  onStatusUpdate: () => void
}
const wrapperStyles = css({ marginLeft: 'auto', display: 'flex', alignItems: 'center' })

export const PartnerPickDevicesListActionsCell: FunctionComponent<Props> = ({
  partnerPickDevice: { id, active },
  onEdit,
  onStatusUpdate,
}) => {
  const editLabel = useDomainMessage('partnerPickDevicesDomain.list.columns.actions.edit')

  const onEditClick = useCallback(() => {
    onEdit(id)
  }, [id, onEdit])

  return (
    <div css={wrapperStyles}>
      <PartnerPickDeviceListSetStatusButton
        deviceId={id}
        currentActive={active}
        onUpdate={onStatusUpdate}
      />
      <Button variant="secondary" onClick={onEditClick} data-testid="partnerPickDeviceList-edit">
        {editLabel}
      </Button>
    </div>
  )
}
